import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', function () {
  const gbBuilderFilteredEventSwipers = document.querySelectorAll('.gb-builder-filtered-event-swiper');

  if (gbBuilderFilteredEventSwipers.length === 0) return;

  function setupGbBuilderFilteredEventSwiper(gbBuilderFilteredEventSwiper) {
    const swiperElement = gbBuilderFilteredEventSwiper.querySelector('.gb-builder-filtered-event-swiper__swiper');

    if (!swiperElement || swiperElement.swiper) return;

    new Swiper(swiperElement, {
      watchOverflow: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      updateOnWindowResize: true,
      allowTouchMove: true,
      loop: false,
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 0,
      pagination: {
        el: gbBuilderFilteredEventSwiper.querySelector('.gb-builder-filtered-event-swiper__pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1,
        },
      },
    });
  }

  gbBuilderFilteredEventSwipers.forEach(setupGbBuilderFilteredEventSwiper);
});
